import { useState } from 'react';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { InputStyle } from 'components/InitialStyle';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { IconButton, InputAdornment, OutlinedInput, Box } from '@mui/material';

type ComponentTypes = {
  name?: any;
  error?: any;
  control?: any;
  label?: string;
  disabled?: boolean;
  showPassword?: boolean;
  togglePwd?: () => void;
};

const CustomInputPassword = ({
  name,
  error,
  control,
  togglePwd,
  label = '',
  showPassword,
  disabled = false,
}: ComponentTypes) => {
  const [show, setShow] = useState(disabled);

  return (
    <Box style={{ width: '100%' }} position='relative'>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <CustomLabel htmlFor={label}>{label}</CustomLabel>

        {show && (
          <Box
            sx={{
              cursor: 'pointer',
              fontFamily: 'Lato',
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '24px',
            }}
            onClick={() => setShow(false)}>
            Изменить
          </Box>
        )}
      </Box>
      <Controller
        name={name}
        control={control}
        rules={{
          required: !show && 'Поле, обязательное для заполнения',
          validate: !show
            ? {
                minLength: (v) => v?.length >= 5,
              }
            : undefined,
        }}
        render={({ field }) => (
          <OutlinedInput
            {...field}
            id={name}
            value={field.value || ''}
            sx={InputStyle}
            disabled={show}
            type={showPassword ? 'text' : 'password'}
            error={Boolean(error[name])}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton disableRipple onClick={togglePwd} edge='end'>
                  {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                </IconButton>
              </InputAdornment>
            }
          />
        )}
      />
      <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: 0, bottom: -15 }}>
        {error?.type === 'required' && error?.message}
      </span>
      <ErrorMessage error={error} name={name} />
    </Box>
  );
};

export default CustomInputPassword;
